import request from "./axios";
const mergeUrl = (url) => {
  return `${window.$configApi.system}${url}`;
};

class Api {
  // 首页布局
  getWebPosition(websiteId) {
    return request.get(mergeUrl(`/rmt/cms/web/indexWebPosition/${websiteId}`));
  }
  // 获取栏目列表
  getInfoList(data) {
    return request.post(mergeUrl(`/rmt/cms/web/indexInfoList`), data);
  }
  // 获取一级栏目列表 yjInfoList
  getInfoList2(data) {
    return request.post(mergeUrl(`/rmt/cms/web/indexInfoList`), data);
  }
  // 轮播图列表
  getPicList(data) {
    return request.post(mergeUrl(`/rmt/cms/web/indexListPic`), data);
  }
  // 获取市县列表
  getSxList(data) {
    return request.post(mergeUrl(`/rmt/cms/web/sxlist`), data);
  }
  // // 获取轮播图
  // getSxList(data) {
  //   return request.post(mergeUrl(`/rmt/cms/web/sxlist`), data);
  // }

  // 获取栏目详情
  getInfoDetail(id) {
    return request.get(mergeUrl(`/rmt/cms/web/getDetail/${id}`));
  }
  // 获取导航布局
  getNavList(webSiteId) {
    return request.get(mergeUrl(`/rmt/cms/column/navList/${webSiteId}`));
  }
  // 获取动态栏目
  getColumnTree(data) {
    return request.post(mergeUrl(`/rmt/cms/web/getColumnTree`), data);
  }

  // 获取上传的文件列表
  getFlieList(data) {
    return request.post(mergeUrl(`/affix/web/webList`), data);
  }
  // 检验文件是否存在
  checkFile(filePath) {
    return request.get(mergeUrl(`/affix/web/webDownload/check/file?filePath=${filePath}`));
  }
  // 下载文件
  downloadFile(params) {
    return request.get(mergeUrl(`/affix/web/webDownload`), params, { responseType: 'blob' });
  }
  // 获取一级栏目列表
  getSearchList(data) {
    return request.post(mergeUrl(`/rmt/cms/web/webSerchList`), data);
  }
  // 获取友情链接
  getNetList(data) {
    return request.post(mergeUrl(`/rmt/cms/web/netList`), data);
  }
  // 获取面包屑
  getColumnPath(data) {
    return request.post(mergeUrl(`/rmt/cms/web/column/path`), data);
  }
  // 获取底部信息
  addFooterCount(websiteId) {
    return request.get(mergeUrl(`/rmt/cms/web/add/count/${websiteId}`));
  }
  // 获取底部信息
  getFooterCount(websiteId) {
    return request.get(mergeUrl(`/rmt/cms/web/get/count/${websiteId}`));
  }
  // 首页小广告
  getPopList(data) {
    return request.post(mergeUrl(`/rmt/cms/web/popList`), data);
  }
}

export default new Api();
